import { useState } from 'react'
import { api } from '../../lib/api'
import { CVButton } from '../../lib/sol/inputs/CVButton'
import { inputSelectAll } from '../../utils/react-ext'

export function LoginPage ({ onAccessGranted }: { onAccessGranted: () => void }) {
	const [code, setCode] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [submitting, setSubmitting] = useState(false)

	const submit = async () => {
		setError(null)
		setSubmitting(true)
		const result = await api.submitAccessCode(code.trim())
		setSubmitting(false)
		if (result.ok) {
			onAccessGranted()
		} else {
			setError(result.err)
		}
	}

	return (
		<div className="min-h-screen w-full flex items-center justify-center px-4 relative z-10">
			<div
				className="flex flex-col items-center gap-5 bg-white/85 backdrop-blur-sm rounded-2xl p-8 shadow-2xl shadow-black/30"
			>
				<h1 className="text-3xl font-title text-neutral-800">Welcome!</h1>
				<p className="text-neutral-600 text-base -mt-2">Please enter your access code to continue.</p>
				<input
					type="text"
					value={code}
					onChange={(e) => (setCode(e.target.value), error && setError(null))}
					onFocus={inputSelectAll}
					placeholder="e.g. CV-abcdefgh..."
					className="rounded-md px-4 py-2 border-2 border-neutral-300 outline-none focus:border-cv-brown-2 transition-colors text-neutral-900 min-w-[20rem] placeholder:text-neutral-300 text-center tracking-wide"
					autoFocus
					autoComplete='current-password'
					onKeyDown={({ key }) => key === 'Enter' && submit()}
				/>
				{error && <p className="text-danger-600 text-sm">{error}</p>}
				<CVButton onClick={() => submit()} isLoading={submitting} disabled={submitting || !code.trim()}>Submit</CVButton>
			</div>
		</div>
	)
}